export default __webpack_public_path__ + "static/media/documents-1.bbd9c602.jpg";